import styled from 'styled-components';
import Image from 'core/common/components/Image';

export const StyledImage = styled(Image)`
  position: absolute;
  z-index: -1000;
  opacity: 0;
  visibility: hidden;
`;
